import { get } from "http";
import { loadModel, loadRecords, saveModel, saveRecord } from "../api/connection";
import { showInputDialog, showSnackbar } from "../components/UniversalDialog";
import { getCreds } from "../contexts/PageContext";
import { OrgOwnedModel } from "../models/BaseModel";
import { Org } from "../models/Org";
import { UserRole } from "../models/User";
import { BaseVisual } from "../visuals/BaseVisual";
import { getCollectionName } from "../models/ModelNavigator";
import { Model } from "../models/Model";
import { downloadOrgBlob, uploadOrgBlob } from "../panels/common/UploadBlob";
import { createOrgBlob } from "../models/OrgBlob";

export async function transferToOrg(record: OrgOwnedModel, copy = false) {
  const { user } = getCreds();
  if (!user || user.role !== UserRole.SystemAdmin) {
    showSnackbar('User not authorized', 'error');
    return false;
  }
  const orgs = await loadRecords<Org>('organizations');
  const orgNames = orgs.map((o) => o.name);
  const orgName = await showInputDialog('Select Organization', 'Organization', orgNames.join(','));
  if (!orgName) {
    return false;
  }
  const targetOrg = orgs.find((o) => o.name === orgName);
  record.orgId = targetOrg!._id;
  if (copy) {
    record._id = '';
  }
  const collectionName = getCollectionName(record);
  if (collectionName === 'models') {
    const model = record as Model;
    if (model.source.blobId) {
      // copy the blob
      const orgBlob = createOrgBlob(model.source.blobId);
      await loadModel(orgBlob);
      const blob = await downloadOrgBlob(model.source.blobId);
      const newBlob = await uploadOrgBlob(orgBlob.type, blob!, "techmage-assets", targetOrg!._id);
      model.source.blobId = newBlob._id;
    }
  }
  if (record instanceof BaseVisual) {
    await record.save();
  } else {
    await saveModel(record);
  }
  return true;
}